var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37.1044,
    height: 35,
    rx: 8,
    fill: "#F7931A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2392 15.9788C24.4978 14.2539 23.1814 13.3268 21.3812 12.7083L21.9652 10.3719L20.5394 10.0175L19.9709 12.2924C19.596 12.1991 19.2111 12.1113 18.8285 12.0242L19.4011 9.73427L17.9762 9.37988L17.3918 11.7155C17.0817 11.6451 16.777 11.5755 16.4814 11.5021L16.4831 11.4947L14.5168 11.005L14.1375 12.524C14.1375 12.524 15.1954 12.7659 15.1731 12.7808C15.7504 12.9245 15.8549 13.3058 15.8375 13.608L15.1723 16.2697C15.2121 16.2797 15.2636 16.2943 15.3205 16.3171C15.273 16.3053 15.2223 16.2925 15.1698 16.2799L14.2374 20.0086C14.1668 20.1836 13.9877 20.4462 13.5841 20.3465C13.5984 20.3671 12.5477 20.0885 12.5477 20.0885L11.8398 21.7165L13.6953 22.1779C14.0405 22.2642 14.3788 22.3546 14.7119 22.4395L14.1219 24.8027L15.5461 25.1571L16.1304 22.819C16.5194 22.9243 16.897 23.0215 17.2667 23.1131L16.6843 25.4402L18.1102 25.7946L18.7002 23.4358C21.1315 23.8948 22.9597 23.7098 23.7292 21.5162C24.3493 19.7501 23.6984 18.7314 22.4192 18.0671C23.3509 17.8528 24.0526 17.2415 24.2397 15.9789L24.2393 15.9786L24.2392 15.9788ZM20.9815 20.5354C20.5409 22.3015 17.5598 21.3468 16.5932 21.1074L17.3762 17.9765C18.3427 18.2172 21.442 18.6935 20.9816 20.5354H20.9815ZM21.4225 15.9532C21.0205 17.5596 18.5393 16.7435 17.7344 16.5433L18.4443 13.7039C19.2492 13.904 21.8412 14.2775 21.4226 15.9532H21.4225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmBtc);
export default __webpack_public_path__ + "static/media/gmBTC.f23c38b9003a84544c6baf688776e7ab.svg";
export { ForwardRef as ReactComponent };